export const getProgressColor = (progress) => {
  if (progress < 50) {
    return "#f7b84b"
  } else if (progress < 100) {
    return {
      '0%': '#f7b84b',
      '100%': '#87d068',
    }
  } else {
    return '#87d068';
  }
}